import Vue from 'vue'
import Router from 'vue-router'
import { store } from '@/store/store'

import controleAcessoRotas from '@/app/ctrlacesso/ControleAcessoRotas'
import contratos from '@/app/contratos/ContratosRotas'
import contratosRelatorios from '@/app/contratos/relatorios/ContratosRelatoriosRotas'
import convenios from '@/app/convenios/ConveniosRotas'
import certidoes from '@/app/certidoes/CertidoesRotas'
import processos from '@/app/processos/ProcessosRotas'
import atestos from '@/app/contratos/atestos/AtestosRotas'
import admin from '@/app/admin/AdminRotas'
// Containers
const DefaultContainer = () => import('@/containers/DefaultContainer')

// App
const Login = () => import('@/app/ctrlacesso/login/Login')
const AtualizarSenha = () => import('@/app/ctrlacesso/usuarios/AtualizarSenha')
const ErroPadrao = () => import('@/shared/components/ErroPadrao')
const ErroNaoAutorizado = () => import('@/shared/components/ErroNaoAutorizado')

Vue.use(Router)

const routes = [
    {
        path: '/',
        name: 'Home',
        component: DefaultContainer,
        beforeEnter: (to, from, next) => {
            if (store.getters.estaAutenticado) {
                next()
            } else {
                store.dispatch('tryAutoLogin')
                if (store.getters.estaAutenticado) {
                    next()
                } else {
                    next({
                        path: '/login',
                        query: {
                            ...to.query,
                            redirect: to.path
                        }
                    })
                }
            }
        },
        children: [
            controleAcessoRotas,
            contratos,
            contratosRelatorios,
            // certidoes,
            processos,
            // atestos,
            admin,
            // convenios
        ]
    },
    {
        path: '/login',
        name: 'Login',
        component: Login
    },
    {
        path: '/atualizarsenha',
        name: 'AtualizarSenha',
        component: AtualizarSenha
    },
    {
        path: '/erro',
        name: 'Erro',
        component: ErroPadrao
    },
    {
        path: '/naoautorizado',
        name: 'Erro_NaoAutorizado',
        component: ErroNaoAutorizado
    }
]

const router = new Router({
    mode: 'hash',
    linkActiveClass: 'open active',
    scrollBehavior: () => ({
        y: 0
    }),
    routes: routes
})

export default router
